import { takeLeading, call, fork, put, select } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'

import { NewUserForm } from '~api/models'
import { UserApi } from '~api/instances'
import { displayAPIError } from '~store/global/sagas'

import { resetForm, setCurrentStep, submitForm, updateFormStepValuesAndSubmit } from './actions'
import { getNewUserFormData } from './selectors'

export function* newUserWizardSagas() {
  yield fork(watchUpdateFormStepValuesAndSubmitForm)
}

/**
 * submit form
 */
function* watchUpdateFormStepValuesAndSubmitForm() {
  yield takeLeading(updateFormStepValuesAndSubmit, function* () {
    try {
      const NewUserFormWizardData: NewUserForm = yield select(getNewUserFormData)
      yield call(submitFormWorker, { newUserForm: NewUserFormWizardData })
      yield put(resetForm())
      yield put(setCurrentStep('success'))
    } catch (e) {
      yield displayAPIError(e, 'watchUpdateFormStepValuesAndSubmitForm')
    }
  })
}

const submitFormWorker = bindAsyncAction(submitForm)(
  function* (props) {
    return yield call([UserApi, UserApi.createUserFromWizard], props)
  },
)
